



























































import Vue from 'vue';

export default Vue.extend({
  name: 'Pagination',
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 5,
    },
    total: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    startPage(): number {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage + Math.floor(this.maxVisibleButtons / 2) > this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return Math.max(this.currentPage - Math.floor(this.maxVisibleButtons / 2), 1);
    },
    endPage(): number {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages(): {
      name: number;
      isDisabled: boolean;
    }[] {
      const range = [];

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }

      return range;
    },
    isInFirstPage(): Boolean {
      return this.currentPage === 1;
    },
    isInLastPage(): Boolean {
      return this.currentPage === this.totalPages;
    },
    totalPages(): number {
      return Math.ceil(this.total / this.perPage);
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit('pageChanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pageChanged', this.currentPage - 1);
    },
    onClickPage(page: number) {
      this.$emit('pageChanged', page);
    },
    onClickNextPage() {
      this.$emit('pageChanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('pageChanged', this.totalPages);
    },
    isPageActive(page: number): Boolean {
      return this.currentPage === page;
    },
  },
});
